import memoizeOne from 'memoize-one';

const isNumberFn = memoizeOne((value: unknown) => {
	return typeof value === 'number' && isFinite(value);
});

export const isNumber = (value: unknown): value is number => isNumberFn(value);
